var map = {
	"./button-hover.png": 27,
	"./button-hover@2x.png": 28,
	"./button.png": 69,
	"./button@2x.png": 70
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/button.*\.png$
// module id = 189
// module chunks = 3